module.exports = __webpack_public_path__ + "img/SR3_Screen_2.c89e3944.jpg";